module.exports = __webpack_public_path__ + "static/media/language.801a916e.svg";